import React, { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { useToast, Spinner, ErrorBanner, EmptyState } from '../../components/ui';
import AddReceivingModal from './AddReceiving';
import { fmt } from '../../utils/format';

export default function Receiving() {
  const { data, loading, error, refetch } = useFetch('/api/receiving');
  const { showToast, Toast } = useToast();
  const [addModal, setAddModal] = useState(false);
  if (loading) return <Spinner />;
  if (error) return <ErrorBanner message={error} onRetry={refetch} />;
  return (
    <div>

      <div className="page-header"><h1>Receiving Log</h1><div className="page-actions"><button className="btn btn-primary btn-sm" onClick={() => setAddModal(true)}><i className="ti ti-plus" /> Record receipt</button></div></div>
      {addModal && <AddReceivingModal onClose={() => setAddModal(false)} onSaved={(msg) => { refetch(); showToast(msg || 'Saved'); }} />}
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>PO #</th><th>Vendor</th><th>Received by</th><th>Date</th><th>Notes</th></tr></thead>
            <tbody>
              {(data || []).map(r => (
                <tr key={r.id}>
                  <td style={{ fontFamily:'monospace', fontSize:12 }}>{r.po_number}</td>
                  <td>{r.vendor_name}</td>
                  <td>{r.received_by_name || '—'}</td>
                  <td style={{ fontSize:12 }}>{fmt.dateTime(r.received_at)}</td>
                  <td style={{ fontSize:12, color:'var(--text-tertiary)' }}>{r.notes || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!(data||[]).length && <EmptyState icon="ti-package-import" message="No receiving records yet" />}
        </div>
      </div>
    </div>
  );
}
